export const initChart = (root?: HTMLElement) => {
  // Stub de controlador de chart: no hace nada por ahora
  console.log('[chart] init', root);
};
